import { createBuilderModule } from '../../register-builder/builder-module';
import { SignUpForm } from './SignUpForm';

export default createBuilderModule(SignUpForm, {
  name: 'SignUpForm',
  image: 'https://cdn.zappy.app/46ccf0301f53cb8425ad63d5f05d7486.png',
  inputs: [
    {
      name: 'googleSSOEnabled',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'facebookSSOEnabled',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'microsoftSSOEnabled',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'hideFieldsUntilFocus',
      type: 'boolean',
      defaultValue: true,
    },
  ],
});
